import React from 'react';
import { Link } from 'react-router-dom';
import './index.css'

function Footer() {
  const handleLinkClick = () => {
    window.scrollTo(0, 0); // Scroll to the top
  };
  
  return (
    <footer>
    <div style={{backgroundColor:'#0C64C3'}} className=" relative pt-8 pb-6">
      <div className="container mx-auto px-4">
      <div className="flex flex-wrap text-left lg:text-left">
      <div className="w-full lg:w-6/12 px-4">
        <h4 className="text-white text-3xl Young text-blueGray-700">Rejoignez-nous!</h4>
        <h5 className=" text-white text-lg mt-2 mb-2 text-blueGray-600 ">
        Rejoignez-nous sur les réseaux sociaux pour rester connecté à YALWAS et pour les dernières mises à jour, offres spéciales et conseils financiers
        </h5>
        <div className="mt-6 lg:mb-0 mb-6">
          <Link to="https://www.facebook.com/YALWAS " target="_blank"><button className="bg-white text-lightBlue-600 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2" type="button">
          <i className="fab fa-facebook-square"></i></button></Link>
          <Link to="https://wa.me/213540139324" target="_blank"><button className="bg-white text-green-600 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2" type="button">
          <i className="fab fa-whatsapp-square"></i></button></Link>
          <Link to="https://m.me/YALWAS" target="_blank"><button className="bg-white text-messenger-blue shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2" type="button">
          <i className="fab fa-facebook-messenger"></i>
        </button></Link>
        <Link to="https://instagram.com/yalwas.offeciel" target="_blank"><button className="bg-white text-instagram-red shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2" type="button">
          <i className="fab fa-instagram"></i>
        </button></Link>
        <Link to="https://www.youtube.com/@yalwas" target="_blank"><button className="bg-white text-instagram-red shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2" type="button">
          <i className="fab fa-youtube"></i>
        </button></Link>
        <Link to="https://www.tiktok.com/@yalwas.com" target="_blank"><button className="bg-white text-tiktok-black shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2" type="button">
          <i className="fab fa-tiktok"></i>
        </button></Link>
        </div>
      </div>
      <div className="w-full lg:w-6/12 px-4">
        <div className="flex flex-wrap items-top mb-6">
          <div className="w-full lg:w-4/12 px-4 ml-auto">
            <span className="text-white block Young uppercase text-blueGray-500 text-sm mb-2">Useful Links</span>
            <ul className="list-unstyled">
              <li>
                <Link onClick={handleLinkClick} className="text-white Comfortaa text-blueGray-600 hover:text-[#D8D9DA]  block pb-2 text-sm" to="/About-Us ">About Us</Link>
              </li>
              <li>
                <Link onClick={handleLinkClick} className="text-white Comfortaa text-blueGray-600 hover:text-[#D8D9DA]  block pb-2 text-sm" to="/Services ">Services</Link>
              </li>
              <li>
                <Link onClick={handleLinkClick} className="text-white Comfortaa text-blueGray-600 hover:text-[#D8D9DA]  block pb-2 text-sm" to="/Contact-Us">Contact Us</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <hr className="my-6 border-blueGray-300"/>
    <div className="flex flex-wrap items-center md:justify-between justify-center">
      <div className="w-full md:w-4/12 px-4 mx-auto text-center">
        <div className="text-white text-sm text-blueGray-500 font-semibold py-1">
          Copyright © <span id="get-current-year">2023 <span className='Young text-[16px]'>Yalwas</span></span>
        </div>
      </div>
      </div>
    </div>
    </div>
    </footer>
  );
}

export default Footer;